import BaseList from './BaseList'

class ListAll extends BaseList {
  type = 'all'

  filterList = () => true
}

export default ListAll